import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// SHCT-259 — PRD 19 §8.3 already-registered state.
// When the invitation token belongs to an account that has ALREADY completed sign-up
// (verifyInvitation → SIGNUP_ALREADY_COMPLETED), render this dedicated card — NOT the
// signup form and NOT a transient auto-redirect modal. Registration is unavailable; the
// user explicitly clicks "Return to login" to leave (no auto-navigation).
export const SignupAlreadyRegisteredCard = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const actionRef = useRef<HTMLButtonElement>(null);

  // Focus the primary action on mount so screen-reader + keyboard users land on the
  // state change and Enter activates "Return to login" immediately.
  useEffect(() => {
    actionRef.current?.focus();
  }, []);

  return (
    <div className="signup-page__registered" role="alert" aria-live="assertive">
      <h2 className="signup-page__registered-title">
        {t('signup.alreadyRegisteredCard.title')}
      </h2>
      <p className="signup-page__registered-desc">{t('signup.alreadyRegisteredCard.body')}</p>
      <button
        ref={actionRef}
        type="button"
        className="btn btn-lg btn-primary signup-page__submit"
        onClick={() => navigate('/login', { replace: true })}
      >
        {t('signup.alreadyRegisteredCard.action')}
      </button>
    </div>
  );
};
